dealershipModule.controller('DealerPreferencesController',
    ["$scope","$rootScope", "dealershipService",
        "imSessionVarsService", "erateSessionVarsService", "DealerPreferences",
        "dealershipModuleConstants","dealerPreferencesService", "$q",
        'TLCError','AppErrorCodes','profitSettingsService','providerFeaturesService',
        function ($scope, $rootScope, dealershipService,
        imSessionVarsService, erateSessionVarsService, DealerPreferences,
        dealershipModuleConstants, dealerPreferencesService, $q,
        TLCError, AppErrorCodes, profitSettingsService, providerFeaturesService) {

        // Passed in via directive attribute: $scope.product

        $scope.modelIsDirty = false;
        $scope.preferences = new DealerPreferences();
        $scope.defaultDeductibleOptions = []; // pick list
        $scope.defaultCoverageOptions = []; // pick list
        $scope.defaultSurchargeOptions = []; // pick list
        $scope.defaultDeductibleSelectedItem = null;
        $scope.defaultCoverageSelectedItem = null;
        $scope.profitSettingRegulationCheck = null;
        $scope.allowDefaultProposal = false;

        $scope.originalPreferences = new DealerPreferences();  // expose in scope for testing

        $scope.init = function() {
            providerFeaturesService.getProviderApplicationSetting("AllowDefaultProposal",'false')
            .then(
                function(element){
                    $scope.allowDefaultProposal = element.toString().toUpperCase() === "TRUE";
                }
            )
            .toString().toUpperCase === 'TRUE';


            profitSettingsService.getProfitSetting($scope.product.productCode, Date.today())
                .then(function (result) {
                    $scope.profitSettingRegulationCheck = result;
                }, function(err) {
                    throw new TLCError(new Error(err),AppErrorCodes.ProfitSettingController_GeneralError);
                });
            dealerPreferencesService.getProviderDefaultDeductibles($scope.product.productCode, Date.today())
            .then(
            function(deductibles) {
                if (angular.isArray(deductibles)) {
                    $scope.defaultDeductibleOptions = deductibles;
                    makeModelClean();
                }
                else {
                    throw new TLCError(new Error("An error occurred retrieving deductible options: incorrect type of data returned"),AppErrorCodes.DealerPrefController_GeneralError);
                }
            },
            function(error) {
                throw new TLCError(new Error("There was an error retrieving deductible options: " + error),AppErrorCodes.DealerPrefController_GeneralError);
            });

            dealerPreferencesService.getProviderDefaultCoverages($scope.product.productCode, Date.today())
                .then(
                function(coverages) {
                    if (angular.isArray(coverages)) {
                        $scope.defaultCoveragesOptions = coverages;
                        makeModelClean();
                    }
                    else {
                        throw new TLCError(new Error("An error occurred retrieving coverage options: incorrect type of data returned"),AppErrorCodes.DealerPrefController_GeneralError);
                    }
                },
                function(error) {
                    throw new TLCError(new Error("There was an error retrieving coverage options: " + error),AppErrorCodes.DealerPrefController_GeneralError);
                });

            $scope.preferences.selectedSurcharges = null;

            dealerPreferencesService.getProviderDefaultSurcharges($scope.product.productCode, Date.today())
                .then(
                    function(surcharges) {
                        if (angular.isArray(surcharges)) {
                            $scope.defaultSurchargeOptions = surcharges;
                            $scope.preferences.selectedSurcharges =
                                $scope.defaultSurchargeOptions
                                    .filter(function(opt) { return opt.UserChoseSurcharge; })
                                    .map(function(opt) { return opt.InternalOptionId; });

                            makeModelClean();
                        }
                        else {
                            throw new TLCError(new Error("An error occurred retrieving surcharge options: incorrect type of data returned"),AppErrorCodes.DealerPrefController_GeneralError);
                        }
                    },
                    function(error) {
                        $scope.preferences.selectedSurcharges = null;
                        //do nothing..just don't show them
                        //throw new TLCError(new Error("There was an error retrieving surcharge options: " + error),AppErrorCodes.DealerPrefController_GeneralError);
                    });

            dealerPreferencesService.getProductDisplayPreferences($scope.product.productCode, $scope.product.productTypeCode, Date.today())
            .then(
            function(responseData) {
                $scope.preferences = responseData;

                if ($scope.profitSettingRegulationCheck.type === 'StateRegulated')
                    $scope.preferences.allowModifyRetail = "false";

                makeModelClean();
            },
            function(err) {
                throw new TLCError(new Error("There was an error retrieving display settings: " + err),AppErrorCodes.DealerPrefController_GeneralError);
            });
        }

        function makeModelClean() {
            $scope.originalPreferences = angular.copy($scope.preferences);
            $scope.modelIsDirty = false;
        }

        $scope.updateDisplayPreferences = function() {
            if ($scope.promiseSave) {
                $scope.promiseSave.resolve();
            }
            // make request to update the database
            if($scope.modelIsDirty) {
                dealerPreferencesService.saveProductDisplayPreferences(
                    $scope.product.productCode,
                    Date.today(),
                    $scope.preferences)
                .then(
                function (response) {
                    makeModelClean();
                    if (angular.equals($scope.profitSetting, $scope.originalProfitSetting)) {
                        $rootScope.$broadcast(dealershipModuleConstants.RERATE_PRODUCT, {productId: $scope.product.productCode, productDed: $scope.preferences.defaultDeductible, productSurcharges: $scope.preferences.selectedSurcharges});
                    }
                },
                function (err) {
                    throw new TLCError(new Error("There was an error updating display settings: " + err),AppErrorCodes.DealerPrefController_GeneralError);
                });
            }
        };

        $scope.revertChanges = function() {
            // restore the model to its original state
            $scope.preferences = angular.copy($scope.originalPreferences);
            $scope.modelIsDirty = false;
        };

        $scope.$watch('preferences', function(newValue, oldValue) {
            $scope.modelIsDirty = !angular.equals($scope.preferences, $scope.originalPreferences);
        }, true); // this 'true' param is essential - it tells the watch to do a value comparison, not a reference compare. Without it, the watch will never run unless you create a new object!

        $scope.init();

        $scope.$on('productSettingsSave', function(e) {
            $scope.updateDisplayPreferences();
        });
        $scope.$on('productSettingsCancel', function(e) {
            $scope.revertChanges();
        });

        $scope.toggleOption = function($index){
            $scope.defaultSurchargeOptions[$index].UserChoseSurcharge = !$scope.defaultSurchargeOptions[$index].UserChoseSurcharge;
            $scope.preferences.selectedSurcharges =
                $scope.defaultSurchargeOptions
                    .filter(function(opt) { return opt.UserChoseSurcharge; })
                    .map(function(opt) { return opt.InternalOptionId; });
        }

}]);
